import "./App.css";
import { RouteList } from "./lib/routes";
import { BrowserRouter } from "react-router-dom";
// import { ThemeProvider } from "@mui/material/styles";
// import { ApplicationContext } from "./lib/context/application_ctx";
// import { Elements } from "@stripe/react-stripe-js";
// import { loadStripe } from "@stripe/stripe-js";
// import { useContext } from "react";
import { PrimeReactProvider } from "primereact/api";

import "primereact/resources/themes/lara-light-cyan/theme.css";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from "@mui/x-date-pickers";
import { ApplicationWrappers } from "./lib/components/applicationWrappers";

function App() {
  // const { clientSecret } = useContext(ApplicationContext);

  // const stripePromise = loadStripe(
  //  'pk_test_51OIXYbSGFIOP7bSaoSFXZbKUPtuVzTcRKbbhccqXYtR4Hp0c0aIi35L735Xy3H4Fux3sIfdJhA5mjAs38FIDj70U00sbBLoq7h'
  // );

  // const options = {
  //   clientSecret,
  //   // Fully customizable with appearance API.
  //   appearance: {
  //     theme: "flat",
  //     variables: {
  //       fontFamily: ' "Gill Sans", sans-serif',
  //       fontLineHeight: "1.5",
  //       borderRadius: "10px",
  //       colorBackground: "#F6F8FA",
  //     },
  //   },
  // };
  return (
    <>
      <BrowserRouter basename="/user">
        <PrimeReactProvider>
          {/* <Elements stripe={stripePromise} options={options}> */}
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <ApplicationWrappers>
            <RouteList />

            </ApplicationWrappers>
            </LocalizationProvider> 
          {/* </Elements> */}
        </PrimeReactProvider>
      </BrowserRouter>
    </>
  );
}

export default App;
